module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-ir-campany-info-a249a3faaf26a2ec9a09ec6e2b4e4def.svg";